import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteHistory,
  getHistory,
  restoreHistory,
  updateHistory,
} from "../../../api";
import EditNewsForm from "../../EditNewsForm";

export default function EditHistory() {
  const location = useLocation();
  const navigate = useNavigate();

  const customSubmitFunction = async (id, title, description, image) => {
    try {
      const result = await updateHistory(id, title, description, image);
      if (result) {
        navigate("/history/all");
      }
    } catch (error) {}
  };

  const publishHistory = async (id) => {
    try {
      await restoreHistory(id);

      navigate("/history/all");
    } catch (error) {}
  };
  const unPublishHistory = async (id) => {
    try {
      await deleteHistory(id);

      navigate("/history/all");
    } catch (error) {
      throw error;
    }
  };

  const getOneHistory = async (id) => {
    try {
      const result = await getHistory(id);
      return result;
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      <Container>
        <EditNewsForm
          ItemId={location?.state?.historyId}
          breadCrumbLink={"History"}
          breadCrumbText={"Edit News"}
          goBackLink={"/history/all"}
          customsubmit={customSubmitFunction}
          publishItem={publishHistory}
          unPublishItem={unPublishHistory}
          getOneItem={getOneHistory}
        />
      </Container>
    </>
  );
}
